export function range(min: number, max: number) {
  return [...Array(max - min + 1)].map((x, i) => i + min);
}

export function rangeDesc(min: number, max: number) {
  return [...Array(max - min + 1)].map((x, i) => max - i);
}

export function last<T>(list: T[]) {
  return list[list.length - 1];
}

export function isEmpty<T>(list: T[]) {
  return list.length === 0;
}
